






































import { createComponent } from "@vue/composition-api";
// eslint-disable-next-line
import { RiskLevels } from "@web-components/types/RiskLevels";

export default createComponent({
  props: {
    riskLevel: {
      type: Number as () => RiskLevels,
      required: true
    }
  },
  setup() {
    return {
      RiskLevels
    };
  }
});
